import { normalizeOpportunityAccountId } from "src/services/api/opportunities/accountNormalize"
import { Grid, Modal, ClientCard, ObjectiveCard } from "src/lib"
import { IImpactedClientsModalProps } from "./types"
import { formatCurrencyBRL, mapPerfilToProfile } from "src/lib/transformers/ClientsOverviewInfo"
import intl from "src/internationalization/intl"
import { useDrawerStore, useMessageStore, useOpportunitiesStore } from "src/store"
import { OpportunitiesState } from "src/store/opportunitiesStore/types"

const ImpactedClientsModal = ({ 
    impactedClients, 
    opportunityTitle,
    recommendation,
    addedAt,
    dueDate,
    impactedClientsCount,
    open, 
    onClose,
    ...props 
}: IImpactedClientsModalProps) => {
    const actualContext = useMessageStore((s: any) => s.actualContext)
    const setJsonContext = useMessageStore((s: any) => s.setJsonContext)
    const findOpportunityByName = useOpportunitiesStore((s: OpportunitiesState) => s.findOpportunityByName)
    const setActualContext = useMessageStore((s: any) => s.setActualContext)
    const openDrawer = useDrawerStore((s: any) => s.openDrawer)

    const handleClickAIButton = async () => {
        if (opportunityTitle) {
            let opportunityData = findOpportunityByName(opportunityTitle);
            if (actualContext !== opportunityTitle) {
                try {
                    setJsonContext(opportunityData);
                    setActualContext(opportunityTitle);
                } catch (error) {
                    console.error("Error setting context:", error);
                }
            }
            openDrawer();
        }
    }

    if (!impactedClients || impactedClients.length === 0) {
        return null
    }

    return (
        <Modal
            {...props}
            onClickAIButton={handleClickAIButton}
            open={open}
            onClose={onClose}
            title={intl('impactedClients')}
        >
            <Grid container direction="column" gap={2}>
                {(opportunityTitle || recommendation || addedAt || dueDate || impactedClientsCount) && (
                    <ObjectiveCard
                        title={opportunityTitle ?? ''}
                        objectiveId=""
                        recommendation={recommendation ?? ''}
                        addedAt={addedAt ?? ''}
                        dueDate={dueDate ?? ''}
                        impactedClients={impactedClientsCount ?? ''}
                        impactedClientsArray={impactedClients}
                        context={opportunityTitle}
                        showImpactedClients={false}
                        showSeeClientsButton={false}
                        fullWidth
                    />
                )}
                
                <Grid
                    container
                    spacing={2}
                    sx={{ maxHeight: '60vh', overflowY: 'auto', alignContent: 'flex-start' }}
                >
                    {impactedClients.map((impactedClient, index) => {
                        if (!impactedClient) return null

                        const clientName =
                            impactedClient.name ?? impactedClient.p?.name ?? "-"
                        const account = normalizeOpportunityAccountId(
                            impactedClient.account ?? impactedClient.p?.account
                        )
                        const perfil =
                            impactedClient.p?.perfil ??
                            (typeof impactedClient.perfil === "string" ? impactedClient.perfil : "")

                        return (
                            <Grid item key={`${clientName}-${account}-${index}`} xs={12} sm={6}>
                                <ClientCard
                                    clientName={clientName}
                                    clientInvestProfile={mapPerfilToProfile(perfil)}
                                    clientAmount={account || "—"}
                                    context={clientName}
                                    opportunityVolume={
                                        formatCurrencyBRL(impactedClient.volumeOportunidade) || 0
                                    }
                                />
                            </Grid>
                        )
                    })}
                </Grid>
            </Grid>
        </Modal>
    )
}

export { ImpactedClientsModal }

